module.exports = __webpack_public_path__ + "images/phone-hero-bg.png";


//////////////////
// WEBPACK FOOTER
// ./_common/images/phone-hero-bg.png
// module id = 156
// module chunks = 1